import { formatDate, strRemoveSpaces, translation as t } from "../../../../inc/helpers";
import Input from "./Input";

export default class InputDate extends Input {
    constructor({ container, input, label, error }) {
        super({ container, input, label, error });

        this._min = this._container.hasAttribute("data-min")
            ? new Date(this._container.getAttribute("data-min"))
            : null;
        this._max = this._container.hasAttribute("data-max")
            ? new Date(this._container.getAttribute("data-max"))
            : null;
    }

    _validate(value) {
        if (!this._required && !value)
            return { flag: null, msg: "" };

        if (this._required && !value)
            return { flag: false, msg: t("ERROR.FieldMandatory") };

        let _value = new Date(value);
        // console.log(_value.getTime());
        // boh io sto controllo l'avevo fatto per un motivo per�
        //if (isNaN(_value.getTime())) 
        //    _value = null;

        //if (!this._required && !_value)
        //    return { flag: null, msg: "" };

        //if (this._required && !_value) 
        //    return { flag: false, msg: "field mandatory" };

        if (!this._min && !this._max)
            return { flag: true, msg: "" };

        if (this._min && _value > this._min)
            return {
                flag: false,
                msg: t("ERROR.Min", [formatDate(this._min, "dd-MM-yyyy")]),
            };

        if (this._max && _value < this._max)
            return {
                flag: false,
                msg: t("ERROR.Max", [formatDate(this._max, "dd-MM-yyyy")]),
            };

        return { flag: true, msg: "" };
    }

    get min() {
        return this._min;
    }
    set min(number) {
        this._min = number;
    }
}